export type ScriptModeSessionState = {
  isActive: boolean;
  canAutoActivateFromScene: boolean;
};

export type ScriptModeSessionInput = {
  enableScriptMode: boolean;
  inScriptScene: boolean;
  isActive: boolean;
  canAutoActivateFromScene: boolean;
};

export function nextScriptModeSessionState(
  input: ScriptModeSessionInput,
): ScriptModeSessionState {
  if (!input.enableScriptMode) {
    return {
      isActive: false,
      canAutoActivateFromScene: input.canAutoActivateFromScene,
    };
  }
  if (!input.inScriptScene) {
    return {
      isActive: input.isActive,
      canAutoActivateFromScene: true,
    };
  }
  if (input.isActive) {
    return {
      isActive: true,
      canAutoActivateFromScene: input.canAutoActivateFromScene,
    };
  }
  if (!input.canAutoActivateFromScene) {
    return {
      isActive: false,
      canAutoActivateFromScene: false,
    };
  }
  return {
    isActive: true,
    canAutoActivateFromScene: input.canAutoActivateFromScene,
  };
}
